import { MessageTypes } from './types';

export const AmeliproMessageTypes: MessageTypes = {
	info: {
		icon: 'information',
		color: 'ap-parme darken-1',
		type: 'light'
	},
	error: {
		icon: 'sensInterdit',
		color: 'ap-red',
		type: 'light'
	},
	warning: {
		icon: 'exclamation',
		textColor: 'ap-yellow darken-4',
		iconBgColor: 'ap-yellow',
		color: 'ap-yellow',
		type: 'dark'
	},
	success: {
		icon: 'ampoule',
		color: 'ap-turquoise darken-1',
		type: 'light'
	}
};
